import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import tulkojumi from 'utils/tulkojumi';
import getHomeURL from 'utils/getHomeURL';
import { Kluda } from 'pages';

const NotFoundQuery = gql`
  query NotFoundQuery($lang: String!) {
    primary: menu(lang: $lang, _id: "primary") {
      items {
        title
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
    secondary: menu(lang: $lang, _id: "scondary") {
      items {
        title
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }

    teksti(lang: $lang, _id: [
      "liepaja_uz_sakumlapu",
      "kluda_404",
      "mes_nevaram_atrast_lapu_kuru_mekleji",
      "noderigas_saites",
      "sakums"
    ]) {
      _id
      text
    }
  }
`;

class NotFound extends React.PureComponent {
  componentDidMount() {
    if (typeof document !== 'undefined') {
      window.gtag && gtag('event', 'page_not_found', {
        event_label: window.location.pathname,
      });
    }
  }

  render() {
    const {
      lang,
      data: {
        loading,
        primary,
        secondary,
        teksti,
        ...rest
      }
    } = this.props;

    if (loading) {
      return null;
    }

    const homeURL = getHomeURL(lang);
    const saites = [
      {
        title: tulkojumi(teksti, 'sakums'),
        path: homeURL,
      },
      ...primary[0].items,
      ...secondary[0].items,
    ];

    return <Kluda saites={saites} teksti={teksti} homeURL={homeURL} />;
  }
}

const NotFoundWithData = graphql(NotFoundQuery, {
  options: ({ lang }) => ({
    variables: {
      lang: lang || 'lv',
    }
  }),
})(NotFound);

export default NotFoundWithData;



// WEBPACK FOOTER //
// ./src/components/NotFound.js